<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form"
                    :model="model"
                    :rules="validatorRules"
                    slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_product_code']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                                prop="code">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_product_code']"
                       v-model="model.code"
                       ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_product_name']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="name">
              <a-input v-model="model.name"
                       :placeholder="language['common.pleaseInput'] + language['gift_product_name']"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_user_app']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="app">
              <a-select v-model="model.app"
                        :options="appList"
                        @change="handlerApp"
                        :disabled="isDisabled">
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_product_price']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="price">
              <a-input v-model="model.price"
                       :placeholder="language['common.pleaseInput'] + language['gift_product_price']" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_market_price']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="marketPrice">
              <a-input v-model="model.marketPrice"
                       :placeholder="language['common.pleaseInput'] + language['gift_market_price']" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_product_vendor']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="supplier">
              <a-select v-model="model.supplier" @change="handlerChange" >
                <a-select-option v-for='(item,index) in vendorMap' :key='item.key' :value='item.key' :label='item.value'>
                  {{item.value}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_merchant_name']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="businessName">
              <a-select v-model="model.businessName" @change="handlerChangeBusinessName" >
                <a-select-option v-for='(v,k) in businessMap' :key='k' :value='k' :label='v'>
                  {{v}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :label="language['gift_product_limit']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol">
              <a-switch v-model="isSwitch"
                        @change="handlerLimited"></a-switch>
              <a-input v-model="model.limited"
                       :placeholder="language['common.pleaseInput'] + language['gift_product_limit']"
                       style="width: 80%;margin-left: 10px;"
                       @change='limitedChange'
                       :disabled="isLimitDisabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item :label="language['gift_up_down']"
                               :labelCol="labelCol3"
                               style="margin-left: 20px;">
              <j-switch v-model="model.status"
                        @change="changeSwitch"></j-switch>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item :label="language['gift_product_virtual']"
                               :labelCol="labelCol3"
                               prop="virtual">
              <j-switch v-model="model.virtual" @change='virtualChange'></j-switch>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :label="language['gift_product_link']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol">
              <a-input v-model="productCode"
                       :placeholder="language['common.pleaseChoose'] + language['gift_product_link']"
                       style="width:75%"
                       disabled></a-input>
              <a-button type="primary"
                        style="left: 2%"
                        @click="handleSelect">{{language['common.selectButton']}}</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_product_thumbnail']"
                               :labelCol="labelCol2"
                               :wrapperCol="wrapperCol2"
                               prop="thumbnail">
              <j-image-upload class="avatar-uploader"
                              :text="language['common.uploadButton']"
                              v-model="model.thumbnail"
                              :upload-source="uploadSource"
                              :isMultiple="false"
                              :biz-path='uploadSource'
                              :maxSize=200
                              :customer-before-upload='beforeUpload'
                              :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :label="language['gift_product_img']"
                               :labelCol="labelCol2"
                               :wrapperCol="wrapperCol2"
                               prop="images">
              <j-image-upload class="avatar-uploader"
                              :text="language['common.uploadButton']"
                              v-model="model.images"
                              :upload-source="uploadSource"
                              :isMultiple="true"
                              :biz-path='uploadSource'
                              :maxSize=200
                              :customer-before-upload='beforeUpload'
                              :disabled="disableSubmit"></j-image-upload>
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item :label="language['gift_product_tag']"
                               :labelCol="labelCol2"
                               :wrapperCol="wrapperCol2"
                               prop="value">
              <div v-for="item in tagList">
                <span>{{item.title}}</span>
                <j-checkbox style="margin-left:20px ;"
                            v-model="item.value"
                            :options="item.tags"
                            @change="handleCheckBox(item.title,item.value)"></j-checkbox>
              </div>

            </a-form-model-item>

          </a-col>

          <a-col :span="12" v-if="notVirtualFlag">
            <a-form-model-item :label="language['weight']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="weight">
              <a-input v-model="model.weight"
                       :placeholder="language['common.pleaseInput'] + language['weight']"
                       style="width:90%;margin-right: 5px;"></a-input>
              <span>g</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="notVirtualFlag">
            <a-form-model-item :label="language['length']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="length">
              <a-input v-model="model.length"
                       :placeholder="language['common.pleaseInput'] + language['length']"
                       style="width:90%;margin-right: 5px;"></a-input>
              <span>cm</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="notVirtualFlag">
            <a-form-model-item :label="language['width']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="width">
              <a-input v-model="model.width"
                       :placeholder="language['common.pleaseInput'] + language['width']"
                       style="width:90%;margin-right: 5px;"></a-input>
              <span>cm</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="notVirtualFlag">
            <a-form-model-item :label="language['hight']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="height">
              <a-input v-model="model.height"
                       :placeholder="language['common.pleaseInput'] + language['hight']"
                       style="width:90%;margin-right: 5px;"></a-input>
              <span>cm</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="notVirtualFlag">
            <a-form-model-item :label="language['fd.effdate']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="validityPeriod">
<!--              <j-date :showTime="false"
                      valueFormat="YYYY-MM-DD"
                      dateFormat="YYYY-MM-DD"
                      v-model="model.validityPeriod"
                      style="width:90%;margin-right: 5px;" />-->
              <a-textarea v-model="model.validityPeriod"
                          :placeholder="language['common.pleaseInput'] + language['fd.effdate']"
                          :auto-size="{ minRows: 5, maxRows: 8 }"></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="notVirtualFlag">
            <a-form-model-item :label="language['gift_product_place']"
                               :labelCol="labelCol"
                               :wrapperCol="wrapperCol"
                               prop="origin">
              <a-input v-model="model.origin"
                       :placeholder="language['common.pleaseInput'] + language['gift_product_place']"
                       style="width:90%;margin-right: 5px;"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12"></a-col>
          <a-col :span="24" v-if='notVirtualFlag'>
            <a-form-model-item :label="language['gift_product_ingredient']"
                               :labelCol="labelCol2"
                               :wrapperCol="wrapperCol2"
                               prop="ingredient">
              <j-editor v-model="model.ingredient"
                        :plugins="JEitorPlugins"></j-editor>

<!--              <a-textarea v-model="model.ingredient"
                          :placeholder="language['common.pleaseInput'] + language['gift_product_ingredient']"
                          :auto-size="{ minRows: 5, maxRows: 8 }"></a-textarea>-->
            </a-form-model-item>
          </a-col>

          <a-col :span="24" >
            <a-form-model-item :labelCol="labelCol2"
                               :wrapperCol="wrapperCol2"
                               :label="language['product_desc']"
                               class="j-field-content"
                               prop="description">
              <j-editor v-model="model.description"
                        :disabled="disableSubmit"
                        :plugins="JEitorPlugins"></j-editor>
            </a-form-model-item>
          </a-col>
        </a-row>

      </a-form-model>

      <gift-product-select-modal ref="modalSelect"
                                 @ok="modalSelect"></gift-product-select-modal>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
import JEditor from '@/components/jeecg/JEditor'
import GiftProductSelectModal from './GiftProductSelectModal'

export default {
  name: 'GiftProductInfoForm',
  components: {
    JEditor,
    GiftProductSelectModal,
  },
  props: {
    //表单禁用
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    vendorList: {
      type: Array,
    },
    appList: {
      type: Array,
    },
  },
  data() {
    const language = this.$store.getters.language
    return {
      model: {
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 10 },
      },

      confirmLoading: false,
      validatorRules: {
        code: [
          { required: true, message: language['common.pleaseInput'] + language['gift_product_code'] },
        ],
        name: [
          { required: true, message: language['common.pleaseInput'] + language['gift_product_name'] },
          {
            min: 0,
            max: 20,
            message: language['common.lengthUnder'] + 20 + language['ispforum.limit.end'],
            trigger: 'blur',
          },
        ],
        supplier: [{ required: true, message: language['common.pleaseChoose'] + language['gift_product_vendor'] }],
        businessName: [{ required: true, message: language['common.pleaseChoose'] + language['gift_merchant_name'] }],
        app: [{ required: true, message: language['common.pleaseChoose'] + language['gift_user_app'] }],
        thumbnail: [{ required: true, message: language['common.pleaseChoose'] + language['gift_product_thumbnail'] }],
        images: [{ required: true, message: language['common.pleaseChoose'] + language['gift_product_img'] }],
        description: [
          { required: true, message: language['common.pleaseChoose'] + language['announcement.msgContent'] },
        ],
        /*ingredient: [
          { required: true, message: language['common.pleaseInput'] + language['gift_product_ingredient'] },
          {
            min: 0,
            max: 4500,
            message: language['common.lengthUnder'] + 4500 + language['ispforum.limit.end'],
            trigger: 'blur',
          },
        ],*/
        status: [{ required: true, message: language['common.pleaseChoose'] + language['gift_up_down'] }],
        price: [
          { required: true, message: language['common.pleaseInput'] + language['gift_product_price'] },
          { message: language['trmorder.positiveInteger'], value: 'z', pattern: /^-?\d+$/ },
        ],
        marketPrice:[
          { required: true, message: language['common.pleaseInput'] + language['gift_market_price'] },
          { message: language['trmorder.positiveInteger'], value: 'z', pattern: /^-?\d+$/ },
        ],
        weight: [
          { required: true, message: language['common.pleaseInput'] + language['weight'] },
          { message: language['trmorder.positiveInteger'], value: 'z', pattern: /^-?\d+$/ },
        ],
        length: [
          { required: true, message: language['common.pleaseInput'] + language['length'] },
          { message: language['trmorder.positiveInteger'], value: 'z', pattern: /^-?\d+$/ },
        ],
        width: [
          { required: true, message: language['common.pleaseInput'] + language['width'] },
          { message: language['trmorder.positiveInteger'], value: 'z', pattern: /^-?\d+$/ },
        ],
        height: [
          { required: true, message: language['common.pleaseInput'] + language['hight'] },
          { message: language['trmorder.positiveInteger'], value: 'z', pattern: /^-?\d+$/ },
        ],
        validityPeriod: [{ required: true, message: language['common.pleaseInput'] + language['fd.effdate'] }],
        //   value: [{ required: true, message: '请选择商品標籤!' }],
      },
      url: {
        add: '/gift/product/add',
        edit: '/gift/product/edit',
        queryById: '/gift/product/queryById',
        tagUrl: '/gift/product/tag/queryTagListByApp',
        vendorListByApp: '/gift/vendor/listByApp',
        businessBySupplier: '/gift/vendor/businessBySupplier'
      },
      JEitorPlugins: 'lists link table textcolor wordcount contextmenu fullscreen',
      currid: '',
      isLimitDisabled: true,
      isSwitch: true,
      productCode: '',
      tagList: [],
      isDisabled: false,
      virtualOpen: false,
      map: new Map(),
      uploadSource: 'gift',
      vendorMap:[],
      businessMap:[],
      notVirtualFlag: true,
    }
  },
  computed: {
    formDisabled() {
      return this.disabled
    },
    language() {
      return this.$store.getters.language
    },
  },
  created() {
    //备份model原始值
    this.modelDefault = JSON.parse(JSON.stringify(this.model))
    this.map = new Map()
  },
  methods: {
    virtualChange(val){
      this.notVirtualFlag = val === 'N'
      console.log(this.notVirtualFlag,"this.notVirtualFlag")
      if (val === 'Y'){
        console.log(val,"aaa");
        /*this.validatorRules.ingredient = [
          {
            min: 0,
            max: 4500,
            message: this.language['common.lengthUnder'] + 4500 + this.language['ispforum.limit.end'],
            trigger: 'blur',
          },
        ];*/
        this.validatorRules.description = [
          { required: false, message: this.language['common.pleaseChoose'] + this.language['announcement.msgContent'] },
        ];
      }else {
        console.log(val,"aaa");
        /*this.validatorRules.ingredient = [
          { required: true, message: this.language['common.pleaseInput'] + this.language['gift_product_ingredient'] },
          {
            min: 0,
            max: 4500,
            message: this.language['common.lengthUnder'] + 4500 + this.language['ispforum.limit.end'],
            trigger: 'blur',
          },
        ];*/
        this.validatorRules.description = [
          { required: true, message: this.language['common.pleaseChoose'] + this.language['announcement.msgContent'] },
        ];

      }
      this.$forceUpdate();
    },
    beforeUpload(file){
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const vm = this; // 保存当前组件实例的引用
      return new Promise((resolve, reject) => {
        reader.onload = function() {
          const img = new Image();
          img.src = this.result;
          img.onload = function() {
            console.log(img,img.width,img.height,"img")
            console.log(img,"img")
            // 对于特殊字符处理
            if (file.name.match(/[?%:;\[\]（）()]/g)) {
              vm.$message.warning("文件名包含特殊字符"+'?%:;[]()（）');
              reject(new Error("文件名不能包含下列特殊字符"+'?%:;[]()（）'));
            }else if (img.width !== 1242 || img.height !== 948){
              vm.$message.warning("圖片需滿足尺寸等於1242*948，請檢查圖片後重新上傳！");
              reject(new Error('上传图片分辨率不能超过 1024x1024 像素'));
            } else {
              resolve(file);
            }
          };
        };
      });
    },
    add(app) {
      this.edit(this.modelDefault)
      this.model.checkTagMap = {}
      this.model.status = 'Y'
      this.isSwitch=false;
      this.isLimitDisabled = true;
      if (app) {
        this.model.app = app
        this.getProductTag(this.model.app)
        this.getVendorList(this.model.app)
        this.isDisabled = true
      }
      this.$forceUpdate();
    },
    edit(record) {
      console.log('编辑',record);
      
      this.model = Object.assign({}, record)
      this.model.status = this.model.status === 1 ? 'Y' : 'N'
      this.model.virtual = this.model.virtual === 1 ? 'Y' : 'N'
      this.isSwitch = this.model.limited > -1 ? true : false
      this.isLimitDisabled = this.model.limited > -1 ? false : true
      this.model.limited = this.model.limited === -1 ? '' : this.model.limited
      this.isDisabled = record.id ? true : false
      this.visible = true
      // 保留商户Code
      this.model.supplierCode = this.model.supplier
      // 商户名称赋值
      this.model.supplier = this.model.supplierName
      this.virtualChange(this.model.virtual);
      this.productCode = this.model.relation;
      if (record.id) {
        this.getProductTag(this.model.app)
        this.getVendorList(this.model.app)
        // 获取商家名称列表
        this.getVendorbusinessList(this.model.supplierName)
      }
    },
    copy(record) {
      this.model = Object.assign({}, record)
      this.model.code = ''
      this.model.id = ''
      this.model.status = this.model.status === 1 ? 'Y' : 'N'
      this.model.virtual = this.model.virtual === 1 ? 'Y' : 'N'
      this.isSwitch = this.model.limited > -1 ? true : false
      this.isLimitDisabled = this.model.limited > -1 ? false : true
      this.model.limited = this.model.limited === -1 ? '' : this.model.limited
      this.isDisabled = record.id ? true : false
      this.visible = true
      // 保留商户Code
      this.model.supplierCode = this.model.supplier
      // 商户名称赋值
      this.model.supplier = this.model.supplierName
      this.virtualChange(this.model.virtual);
      this.productCode = this.model.relation;
      if (record.id) {
        this.getProductTag(this.model.app)
        this.getVendorList(this.model.app)
        // 获取商家名称列表
        this.getVendorbusinessList(this.model.supplierName)
      }
      this.model.copy = true
      console.log('copy.........', this.model)
    },
    initTagData() {
      this.map = this.model.checkTagMap
    },

    submitForm() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
            if (!this.model.copy) {
              // 普通新增: businessName 对应下拉框选中的 key
              this.model.bcode = this.model.businessName
              this.model.businessName = this.businessMap[this.model.businessName] // 赋值商家名称
            }
          } else if(!this.model.copy) {
            httpurl += this.url.edit
            method = 'put'
          }

          if(method === 'put' || this.model.copy){
            // 修改或复制时特殊处理
            if(this.model.supplier===this.model.supplierName){
              // 未变更商户 还原Code
              this.model.supplier = this.model.supplierCode
            }
            if(this.businessMap[this.model.businessName]){
              // 变更商家
              this.model.bcode = this.model.businessName
              this.model.businessName = this.businessMap[this.model.businessName]
            }
          }
          this.model.relation = this.productCode
          this.model.virtual = this.model.virtual === 'Y' ? 1 : 0
          this.model.status = this.model.status === 'Y' ? 1 : 0
          if(this.model.limited === '') {
            this.model.limited = -1
          }
          that.confirmLoading = true
          //   this.model.images =  this.model.images.replace(/,/g,'||')
          if(method==='put'||this.model.copy) {
            this.model.supplierCode = this.model.supplier // 補丁
            this.model.supplier = this.model.supplierName
          }
          console.log('提交',this.model);
          httpAction(httpurl, this.model, method)
            .then((res) => {
              console.log(res);
              
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
                if(method == 'post' && !this.model.copy){
                  // 还原商家代码
                  this.model.businessName = this.model.bcode
                }
                if(method === 'put' || this.model.copy){
                  // 还原商户
                  this.model.supplier = this.model.supplierName
                  if(this.businessMap[this.model.bcode]) {
                    this.model.businessName = this.model.bcode
                  }
                }
                
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },

   handlerChange(val) {
    console.log('supplier->',val);
    
      this.model.supplier = val
      this.model.businessName = ""
      this.getVendorbusinessList(val)
      this.$forceUpdate();
    },
    handlerChangeBusinessName(val) {
      this.model.businessName = val
      this.$forceUpdate();
    },
    limitedChange(val){
      this.$forceUpdate();
    },
    handlerLimited(checked) {
      console.log('handlerLimited checked : ',checked)
      console.log('this.model.limited : ',this.model.limited)
      this.isSwitch = checked
      this.isLimitDisabled = !checked
      if(!checked) {
        this.model.limited = undefined;
      }
    },
    handleSelect() {
      console.log("this.productCode",this.productCode)
      this.$refs.modalSelect.open(this.productCode, this.model.app)
    },
    modalSelect(val) {
      console.log('modalSelect::::', val)
      this.productCode = val
    },
    handlerApp(val) {
      console.log('handlerApp val : ', val)
      this.getProductTag(val)
      this.getVendorList(val);
      this.model.supplier = "";
    },
    getVendorList(val){
      getAction(this.url.vendorListByApp,{appCode:val}).then(res=>{
        if (res.success){
          this.vendorMap = []
          res.result.forEach(element => {
            this.vendorMap.push({
              key:element.name,
              value:element.name
            })
          });
          console.log('商户', this.vendorMap);
          
        }
      })
    },
    getVendorbusinessList(val){
      console.log('this.model',this.model);
      getAction(this.url.businessBySupplier,{supplier:val,appCode:this.model.app}).then(res=>{
        if (res.success){
          this.businessMap = res.result;
          console.log('商家列表', res);
        }
      })
    },
    getProductTag(val) {
      getAction(this.url.tagUrl, { app: val })
        .then((res) => {
          if (res.success) {
            let keyArr = Object.keys(res.result[0])
            this.tagList = keyArr.map((item, index, arr) => {
              let c = { title: item, tags: res.result[0][item], value: this.model.tag }
              return c
            })
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },

    changeSwitch(val) {
      console.log('changeSwitch : ', val)
      // this.model.status = val ? 1 : 0
    },

    onChange(checkedValues) {},

    handleCheckBox(title, val) {
      this.model.checkTagMap[title] = val
    },
  },
}
</script>
